module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-03-ab592b46d14d064e9f80bd70d6eaef72.svg";